import { jsPDF } from "jspdf";

const BLUE = [46, 123, 228];
const DARK = [11, 15, 23];
const SLATE = [100, 116, 139];

export function buildQuoteDoc(q, company) {
  const doc = new jsPDF({ unit: "pt", format: "letter" });
  const W = doc.internal.pageSize.getWidth();
  let y = 0;

  // Header band
  doc.setFillColor(...DARK); doc.rect(0, 0, W, 84, "F");
  doc.setTextColor(255, 255, 255); doc.setFont("helvetica", "bold"); doc.setFontSize(20);
  doc.text("SiteControl", 48, 42);
  doc.setTextColor(...BLUE); doc.text("HQ", 48 + doc.getTextWidth("SiteControl"), 42);
  doc.setTextColor(148, 163, 184); doc.setFont("helvetica", "normal"); doc.setFontSize(11);
  doc.text(company || "", 48, 62);
  doc.setTextColor(...BLUE); doc.setFont("helvetica", "bold"); doc.setFontSize(13);
  doc.text("QUOTE", W - 48, 42, { align: "right" });
  doc.setTextColor(148, 163, 184); doc.setFont("helvetica", "normal"); doc.setFontSize(11);
  doc.text(q.number || "", W - 48, 62, { align: "right" });

  y = 116;
  doc.setTextColor(...DARK); doc.setFontSize(11);
  doc.text(`Prepared for: ${q.customer_name || "Customer"}`, 48, y); y += 18;
  doc.setTextColor(...SLATE); doc.setFontSize(9);
  doc.text(`Status: ${(q.status || "draft").toUpperCase()}`, 48, y); y += 22;

  if (q.summary) {
    doc.setTextColor(...DARK); doc.setFontSize(10);
    const lines = doc.splitTextToSize(q.summary, W - 96);
    doc.text(lines, 48, y); y += lines.length * 13 + 8;
  }

  // Line items table header
  doc.setFillColor(241, 245, 249); doc.rect(48, y, W - 96, 22, "F");
  doc.setTextColor(...DARK); doc.setFont("helvetica", "bold"); doc.setFontSize(9);
  doc.text("ITEM", 56, y + 15);
  doc.text("QTY", W - 250, y + 15, { align: "right" });
  doc.text("UNIT", W - 160, y + 15, { align: "right" });
  doc.text("AMOUNT", W - 56, y + 15, { align: "right" });
  y += 30;

  doc.setFont("helvetica", "normal"); doc.setFontSize(10);
  (q.line_items || []).forEach((li) => {
    if (y > doc.internal.pageSize.getHeight() - 120) { doc.addPage(); y = 56; }
    const amt = (li.qty || 0) * (li.unit_price || 0);
    doc.setTextColor(...DARK);
    const name = doc.splitTextToSize(li.item || "Item", W - 320);
    doc.text(name, 56, y);
    doc.text(String(li.qty || 0), W - 250, y, { align: "right" });
    doc.text(`$${(li.unit_price || 0).toFixed(2)}`, W - 160, y, { align: "right" });
    doc.text(`$${amt.toFixed(2)}`, W - 56, y, { align: "right" });
    y += Math.max(name.length * 12, 16) + 4;
    doc.setDrawColor(226, 232, 240); doc.line(56, y - 6, W - 56, y - 6);
  });

  // Totals
  y += 8;
  const totRow = (label, val, bold) => {
    doc.setFont("helvetica", bold ? "bold" : "normal");
    doc.setFontSize(bold ? 13 : 10); doc.setTextColor(...(bold ? BLUE : SLATE));
    doc.text(label, W - 200, y);
    doc.setTextColor(...(bold ? DARK : SLATE));
    doc.text(`$${(val || 0).toFixed(2)}`, W - 56, y, { align: "right" }); y += bold ? 22 : 16;
  };
  totRow("Subtotal", q.subtotal);
  totRow(`Tax (${q.tax_rate || 0}%)`, q.tax);
  totRow("Total", q.total, true);

  // Payment schedule
  if ((q.payment_schedule || []).length) {
    y += 10;
    doc.setFont("helvetica", "bold"); doc.setFontSize(11); doc.setTextColor(...DARK);
    doc.text("Payment schedule", 48, y); y += 16;
    doc.setFont("helvetica", "normal"); doc.setFontSize(9); doc.setTextColor(...SLATE);
    q.payment_schedule.forEach((m) => {
      doc.text(`• ${m.label} ${m.mode === "percent" ? `(${m.value}%)` : ""}`, 56, y);
      doc.text(`$${(m.amount || 0).toFixed(2)}${m.status === "paid" ? "  PAID" : ""}`, W - 56, y, { align: "right" });
      y += 15;
    });
  }

  if (q.notes) {
    y += 12; doc.setFont("helvetica", "bold"); doc.setFontSize(10); doc.setTextColor(...DARK);
    doc.text("Notes", 48, y); y += 14; doc.setFont("helvetica", "normal"); doc.setTextColor(...SLATE);
    doc.setFontSize(9); const nl = doc.splitTextToSize(q.notes, W - 96); doc.text(nl, 48, y);
  }

  const pages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pages; i++) {
    doc.setPage(i); doc.setFontSize(8); doc.setTextColor(148, 163, 184);
    doc.text(`${company || "SiteControlHQ"} · ${q.number || ""} · page ${i}/${pages}`,
             W / 2, doc.internal.pageSize.getHeight() - 24, { align: "center" });
  }
  return doc;
}

export function generateQuotePdf(q, company) {
  buildQuoteDoc(q, company).save(`${(q.number || "quote")}.pdf`);
}

export function quotePdfBase64(q, company) {
  return buildQuoteDoc(q, company).output("datauristring");
}
